<template>
    <div>
        <table class="table is-fullwidth is-narrow">
            <thead>
            <tr>
                <th>User:</th>
                <th>LOT#:</th>
                <th>Type:</th>
                <th>Grade:</th>
                <th>Km's:</th>
                <th>Year:</th>
                <th>Color:</th>
                <th>CC:</th>
                <th>Score:</th>
                <th>Bid:</th>
                <!--<th>Status:</th>-->
                <th>End:</th>
            </tr>
            </thead>
            <tbody>
                <table-row v-for="bid in bids" v-bind:bid="bid" v-bind:key="bid.id"></table-row>
            </tbody>
        </table>
        <div class="columns" v-if="showMore">
            <div class="column has-text-centered">
                <button class="button is-large" @click.prevent="loadMore()">
                    <span>Load More</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import apiHistory from '../../api/apiHistory'
    import HistoryTableRow from './HistoryTableRow'
    export default {
        components: {
            tableRow: HistoryTableRow
        },
        data() {
            return {
                bids: [],
                showMore: false
            }
        },
        methods: {
            loadMore() {
                apiBids
                    .bidsListRequest(this.query)
                    .then((response) => {
                        this.bids.push.apply(this.bids, response.data.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        mounted() {
            apiHistory
                .historyListRequest()
                .then((response) => {
                    this.bids = response.data.data
                    if (response.data.total > 30) this.showMore = true
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/History/HistoryTable.vue